import { render } from "./MyinvInterest.vue?vue&type=template&id=091d1b8e&scoped=true&ts=true"
import script from "./MyinvInterest.vue?vue&type=script&lang=ts"
export * from "./MyinvInterest.vue?vue&type=script&lang=ts"

import "./MyinvInterest.vue?vue&type=style&index=0&id=091d1b8e&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091d1b8e"]])

export default __exports__